(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-add-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-add');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-add');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);
  
  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop; 
    }
     
    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balcony"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('balcony-next');
      const events = Array.prototype.slice.apply(document.getElementById('balcony-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected'); 
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bathroom"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('bathroom-next');
      const events = Array.prototype.slice.apply(document.getElementById('bathroom-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');  
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-image-library"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (!window.ComponentRegistry) return;

  function init(root) {
    const track = root.querySelector('.ndev-image-library__track');
    if (!track) return;

    const children = Array.from(track.children);
    children.forEach((child) => track.appendChild(child.cloneNode(true)));

    const originalWidth = track.scrollWidth / 2;
    const speed = 60;
    const duration = originalWidth / speed;
    track.style.setProperty('--scroll-duration', duration + 's');
  }

  function dispose(root) {
    const track = root.querySelector('.ndev-image-library__track');
    if (!track) return;

    const children = track.children;
    const originalCount = Math.floor(children.length / 2);
    while (children.length > originalCount) {
      track.removeChild(children[children.length - 1]);
    }
    track.style.removeProperty('--scroll-duration');
  }

  ComponentRegistry.register({
    ns: 'ndev-image-library',
    mode: 'component',
    selector: '[data-ndev-image-library]',
    init: init,
    dispose: dispose
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-navbar';
    const ROOT_SELECTOR = '[data-ndev-navbar]';
    const SCROLL_BTN_SELECTOR = '[data-btn-purpose="scroll"]';
    const MAIN_SECTIONS_SELECTOR = '#main-content .shopify-section';
    const SITE_HEADER_SELECTOR = '#site-header';

    const LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    const LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function getHeaderOffsetHeight(root, headerEl) {
      let offset = 0;
      if (headerEl) offset += Math.round(headerEl.getBoundingClientRect().height || 0);
      if (root && root.classList.contains('is-sticky')) offset += Math.round(root.getBoundingClientRect().height || 0);
      return offset;
    }

    function updateStickyTop(root, headerEl) {
      if (!root || !root.classList.contains('is-sticky')) return;
      requestAnimationFrame(() => {
        const top = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom || 0) : 0;
        const host = root.__ndevStickyHost && root.__ndevStickyHost.style ? root.__ndevStickyHost : root;
        host.style.setProperty('--ndev-navbar-sticky-top', top + 'px');
      })
    }

    function setActive(root, item, state) {
      if (!root || !item) return;

      var listContainer = root.querySelector('.ndev-navbar__list');
      if (!listContainer) return;

      // 始终更新指示器位置（resize 时 activeItem 不变但仍需修正偏移）
      var btnWrapper = item.closest('.ndev-button');
      var indicator = root.querySelector('.ndev-navbar__indicator');
      if (indicator && btnWrapper) {
        var container = root.querySelector('.ndev-navbar__container');
        var containerRect = container ? container.getBoundingClientRect() : listContainer.getBoundingClientRect();
        var btnRect = btnWrapper.getBoundingClientRect();
        var offsetX = btnRect.left - containerRect.left;
        indicator.style.transform = 'translateX(' + offsetX + 'px)';
        indicator.style.width = btnRect.width + 'px';
      }

      // resize 时仅修正指示器，不重复 toggle class / 滚动
      if (state && state.activeItem === item) return;

      listContainer.querySelectorAll('.ndev-button .ndev-button__btn').forEach(function (el) {
        el.classList.remove('is-active');
      });

      item.classList.add('is-active');
      if (state) state.activeItem = item;

      var r = (btnWrapper || item).getBoundingClientRect();
      var c = listContainer.getBoundingClientRect();
      var center = r.left - c.left + r.width / 2;
      var left = Math.max(0, center - listContainer.clientWidth / 2);
      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      listContainer.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, headerOffset) {
      if (!cachedSections.length) return null;

      var marker = headerOffset + 1;
      var globalIdx = 1;
      for (var i = cachedSections.length - 1; i >= 0; i--) {
        var rect = cachedSections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      var matched = null;
      for (var j = 0; j < anchorKeys.length; j++) {
        if (anchorKeys[j] <= globalIdx) matched = anchorKeys[j];
      }
      return matched;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      var headerEl = document.querySelector(SITE_HEADER_SELECTOR);
      var mainContent = document.querySelector('#main-content');
      var cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));

      function refreshSectionsCache() {
        cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));
      }

      var mo = null;
      if (mainContent && window.MutationObserver) {
        mo = new MutationObserver(refreshSectionsCache);
        mo.observe(mainContent, { childList: true });
      }

      var state = {
        activeItem: null,
        lock: null,
      };

      // 设置 sticky host
      if (root.classList.contains('is-sticky')) {
        var host = root.closest('.shopify-section') || root.parentElement;
        if (host && host.classList) {
          host.classList.add('ndev-navbar__sticky-wrapper');
          root.__ndevStickyHost = host;
        }
      }

      updateStickyTop(root, headerEl);

      // 收集所有带 data-ndev-btn-scroll 属性的按钮，构建映射
      var anchorItemMap = {};
      var anchorKeys = [];
      var listContainer = root.querySelector('.ndev-navbar__list');
      if (listContainer) {
        listContainer.querySelectorAll(SCROLL_BTN_SELECTOR).forEach(function (el) {
          var ai = parseInt(el.getAttribute('data-scroll-section-index') || '', 10);
          if (ai) anchorItemMap[ai] = el;
        });
      }
      anchorKeys = Object.keys(anchorItemMap)
        .map(Number)
        .sort(function (a, b) {
          return a - b;
        });

      // 默认激活第一个
      if (anchorKeys.length > 0 && anchorItemMap[anchorKeys[0]]) {
        setActive(root, anchorItemMap[anchorKeys[0]], state);
      }

      var ticking = false;
      var lockIdleTimer = null;
      var lockMaxTimer = null;
      var unbindUserCancel = null;

      function clearLock() {
        state.lock = null;
        if (lockIdleTimer) {
          clearTimeout(lockIdleTimer);
          lockIdleTimer = null;
        }
        if (lockMaxTimer) {
          clearTimeout(lockMaxTimer);
          lockMaxTimer = null;
        }
        if (unbindUserCancel) {
          unbindUserCancel();
          unbindUserCancel = null;
        }
      }

      function syncActiveByScroll() {
        if (state.lock) return;
        var offset = getHeaderOffsetHeight(root, headerEl);
        var matched = computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, offset);
        if (matched !== null && anchorItemMap[matched]) setActive(root, anchorItemMap[matched], state);
      }

      function bindUserIntentCancel() {
        function onWheel() {
          if (state.lock) clearLock();
        }
        function onTouchStart() {
          if (state.lock) clearLock();
        }
        function onPointerDown() {
          if (state.lock) clearLock();
        }
        function onKeyDown(ev) {
          if (!state.lock) return;
          var k = ev && ev.key ? ev.key : '';
          if (
            k === 'ArrowUp' ||
            k === 'ArrowDown' ||
            k === 'PageUp' ||
            k === 'PageDown' ||
            k === 'Home' ||
            k === 'End' ||
            k === ' ' ||
            k === 'Spacebar'
          )
            clearLock();
        }
        window.addEventListener('wheel', onWheel, { passive: true, capture: true });
        window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
        window.addEventListener('pointerdown', onPointerDown, { passive: true, capture: true });
        window.addEventListener('keydown', onKeyDown, true);
        return function () {
          window.removeEventListener('wheel', onWheel, true);
          window.removeEventListener('touchstart', onTouchStart, true);
          window.removeEventListener('pointerdown', onPointerDown, true);
          window.removeEventListener('keydown', onKeyDown, true);
        };
      }

      function beginLock() {
        clearLock();
        state.lock = true;
        unbindUserCancel = bindUserIntentCancel();
        lockMaxTimer = setTimeout(function () {
          clearLock();
          syncActiveByScroll();
        }, LOCK_MAX_MS);
      }

      function armIdleUnlock() {
        if (lockIdleTimer) clearTimeout(lockIdleTimer);
        lockIdleTimer = setTimeout(function () {
          if (!state.lock) return;
          clearLock();
          syncActiveByScroll();
        }, LOCK_IDLE_MS);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateStickyTop(root, headerEl);

          if (state.lock) {
            armIdleUnlock();
            return;
          }

          syncActiveByScroll();
        });
      }

      // 监听按钮点击（capture 阶段），设置锁定
      function onClickCapture(ev) {
        var target = ev && ev.target ? ev.target : null;
        if (!target || !target.closest) return;
        var btn = target.closest(SCROLL_BTN_SELECTOR);
        if (!btn || !root.contains(btn)) return;

        // 立即设置激活状态
        setActive(root, btn, state);

        // 设置锁定，防止滚动回显覆盖
        beginLock();
      }

      root.addEventListener('click', onClickCapture, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      onScroll();

      var ro = null;
      if (headerEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () {
          updateStickyTop(root, headerEl);
          onScroll();
        });
        ro.observe(headerEl);
      }

      controllers.set(root, {
        destroy: function () {
          clearLock();
          root.removeEventListener('click', onClickCapture, true);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          if (ro && ro.disconnect) ro.disconnect();
          if (mo && mo.disconnect) mo.disconnect();
          var stickyHost = root.__ndevStickyHost;
          if (stickyHost && stickyHost.classList) stickyHost.classList.remove('ndev-navbar__sticky-wrapper');
          delete root.__ndevStickyHost;
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        initOne(root);
      });
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        destroyOne(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'page-banner';
    const ROOT_SELECTOR = '[data-page-banner]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      const swiperEl = root.querySelector('[data-page-banner-swiper]');
      if (!swiperEl || typeof window.Swiper === 'undefined') return;

      const configEl = root.querySelector('[data-page-banner-config]');
      let config = {};
      if (configEl && configEl.textContent) {
        try { config = JSON.parse(configEl.textContent); } catch (e) {}
      }

      // 注意：Swiper 初始化时可能会触发 slideChange（会调用 updateVerticalTabs/updateHorizontalTabs）
      // 因此这些变量必须在 new Swiper() 之前完成初始化，避免 TDZ 报错导致整个初始化中断。
      const verticalTabsContainer = root.querySelector('[data-page-banner-vertical-tabs]');
      const horizontalTabsContainer = root.querySelector('[data-page-banner-horizontal-tabs]');
      const horizontalTabsPcContainer = root.querySelector('[data-page-banner-horizontal-tabs-pc]');
      const itemHeight = 19.2;

      // 兼容两种 DOM 形态：
      // - Theme Editor: `.swiper-wrapper > .shopify-block > .swiper-slide.page-banner__slide`
      // - Storefront/Preview: `.swiper-wrapper > .swiper-slide.page-banner__slide`
      const slideWrappers = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block'));
      const hasShopifyBlockWrapper = slideWrappers.length > 0;
      const slideEls = hasShopifyBlockWrapper
        ? slideWrappers
        : Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .page-banner__slide'));

      const slideCount = slideEls.length;
      const enableLoop = slideCount > 1;
      const duration = (Number(config.duration) || 5) * 1000;
      const enableAutoplay = config.autoplay !== false;
      const showPagination = config.showPagination !== false;
      const paginationVariant = (config.paginationVariant || root.getAttribute('data-page-banner-pagination-variant') || 'tabs');
      const useCustomTabs = (paginationVariant === 'tabs' || paginationVariant === 'tabs_pc_horizontal');

      const listeners = [];
      let resizeTimeout = null;
      let progressInterval = null;
      let currentProgress = 0;

      function on(el, type, handler) {
        if (!el) return;
        el.addEventListener(type, handler);
        listeners.push({ el, type, handler });
      }

      let swiper = null;

      const swiperOptions = {
        loop: enableLoop,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: enableLoop,
        allowTouchMove: enableLoop,
        autoplay: enableAutoplay ? { delay: duration, disableOnInteraction: false } : false,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        on: {
          slideChange: function () {
            if (showPagination && useCustomTabs) {
              updateVerticalTabs(this.realIndex);
              updateHorizontalTabs(this.realIndex);
              updateHorizontalTabsPc(this.realIndex);
              resetProgress(this);
            }
          }
        }
      };

      if (hasShopifyBlockWrapper) {
        swiperOptions.slideClass = 'shopify-block';
      } else {
        swiperOptions.slideClass = 'page-banner__slide';
      }

      swiper = new Swiper(swiperEl, swiperOptions);

      function buildTabs() {
        if (verticalTabsContainer) verticalTabsContainer.innerHTML = '';
        if (horizontalTabsContainer) horizontalTabsContainer.innerHTML = '';
        if (horizontalTabsPcContainer) horizontalTabsPcContainer.innerHTML = '';

        if (!showPagination || slideCount <= 1 || !useCustomTabs) {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
          return;
        }

        if (verticalTabsContainer) {
          verticalTabsContainer.style.removeProperty('display');
          verticalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsContainer) {
          horizontalTabsContainer.style.removeProperty('display');
          horizontalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsPcContainer) {
          horizontalTabsPcContainer.style.removeProperty('display');
          horizontalTabsPcContainer.style.setProperty('--count', slideCount);
        }

        slideEls.forEach((holder, index) => {
          const slide = (holder && holder.classList && holder.classList.contains('page-banner__slide'))
            ? holder
            : (holder ? holder.querySelector('.page-banner__slide') : null);
          const title = (slide && slide.getAttribute && slide.getAttribute('data-tab-title')) || ('Slide ' + (index + 1));
          if (verticalTabsContainer && paginationVariant === 'tabs') {
            const vTab = document.createElement('div');
            vTab.className = 'page-banner__vertical-tab' + (index === 0 ? ' page-banner__vertical-tab--active' : '');
            vTab.textContent = title;
            verticalTabsContainer.appendChild(vTab);
          }

          if (horizontalTabsPcContainer && paginationVariant === 'tabs_pc_horizontal') {
            const pcTab = document.createElement('div');
            pcTab.className = 'page-banner__horizontal-tab-pc' + (index === 0 ? ' page-banner__horizontal-tab-pc--active' : '');
            if (title) {
              const span = document.createElement('span');
              span.className = 'page-banner__horizontal-tab-pc-title';
              span.textContent = title;
              pcTab.appendChild(span);
            }
            horizontalTabsPcContainer.appendChild(pcTab);
          }

          if (horizontalTabsContainer) {
            const hTab = document.createElement('div');
            hTab.className = 'page-banner__horizontal-tab' + (index === 0 ? ' page-banner__horizontal-tab--active' : '');
            horizontalTabsContainer.appendChild(hTab);
          }
        });
      }

      function startProgress() {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        const updateInterval = 50;
        const progressStep = (100 / (duration / updateInterval));
        progressInterval = setInterval(() => {
          currentProgress += progressStep;
          if (currentProgress >= 100) {
            currentProgress = 100;
            clearInterval(progressInterval);
          }
          if (verticalTabsContainer) {
            const heightInPixels = (currentProgress / 100) * itemHeight;
            verticalTabsContainer.style.setProperty('--actived-item-height', heightInPixels + 'px');
          }
          if (activeHorizontalTab) {
            activeHorizontalTab.style.setProperty('--progress-width', currentProgress + '%');
          }
          if (activeHorizontalTabPc) {
            activeHorizontalTabPc.style.setProperty('--progress-width', currentProgress + '%');
          }
        }, updateInterval);
      }

      function stopProgress() {
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
      }

      function resetProgress(swiperInstance) {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        if (verticalTabsContainer) {
          verticalTabsContainer.style.setProperty('--actived-item-height', '0px');
        }
        if (activeHorizontalTab) {
          activeHorizontalTab.style.setProperty('--progress-width', '0%');
        }
        if (activeHorizontalTabPc) {
          activeHorizontalTabPc.style.setProperty('--progress-width', '0%');
        }
        const s = swiperInstance || swiper;
        if (enableAutoplay && s && s.autoplay && s.autoplay.running) {
          setTimeout(() => startProgress(), 100);
        }
      }

      function updateVerticalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__vertical-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__vertical-tab--active');
          else tab.classList.remove('page-banner__vertical-tab--active');
        });
        if (verticalTabsContainer && tabs.length > 0) {
          const itemGap = 18;
          const topPosition = realIndex * (itemHeight + itemGap);
          verticalTabsContainer.style.setProperty('--top', topPosition + 'px');
        }
      }

      function updateHorizontalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab--active');
          else tab.classList.remove('page-banner__horizontal-tab--active');
        });
      }

      function updateHorizontalTabsPc(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab-pc--active');
          else tab.classList.remove('page-banner__horizontal-tab-pc--active');
        });
      }

      function initTabs() {
        const vTabs = root.querySelectorAll('.page-banner__vertical-tab');
        const hTabs = root.querySelectorAll('.page-banner__horizontal-tab');
        const hPcTabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        vTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hPcTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
      }

      function initButtonActions() {
        const buttons = root.querySelectorAll('.page-banner__btn');
        buttons.forEach(button => {
          on(button, 'click', function (e) {
            const actionType = this.getAttribute('data-action-type');
            if (actionType === 'scroll') {
              e.preventDefault();
              const sectionIndex = parseInt(this.getAttribute('data-scroll-to-section'), 10) || 1;
              const sections = Array.from(document.querySelectorAll('#main-content .shopify-section') || []);
              const targetSection = sections[sectionIndex - 1];
              if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } else if (actionType === 'spin') {
              e.preventDefault();
              var spinLink = this.getAttribute('data-spin-link');
              if (spinLink) {
                location.href = spinLink;
                return;
              }
              var spinTrigger = document.getElementById('crazyrocket-launch-icon');
              if (spinTrigger) {
                spinTrigger.click();
              }
            }
          });
        });
      }

      function isInteractiveTarget(target) {
        if (!target || !target.closest) return false;
        return Boolean(
          target.closest(
            'a, button, input, textarea, select, option, label, summary, [role="button"], [data-page-banner-no-slide-link]'
          )
        );
      }

      function navigateBySlide(slide) {
        if (!slide) return;
        const href = slide.getAttribute('data-slide-href');
        if (!href) return;
        const target = slide.getAttribute('data-slide-target');
        if (target === '_blank') window.open(href, '_blank');
        else window.location.href = href;
      }

      function initSlideLinkActions() {
        // 用事件委托覆盖 loop 下的克隆 slide（clone 节点不会继承监听器）
        on(swiperEl, 'click', function (e) {
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const slide = e && e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          navigateBySlide(slide);
        });

        on(swiperEl, 'keydown', function (e) {
          if (!e) return;
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const key = e.key || e.code;
          if (!(key === 'Enter' || key === ' ' || key === 'Spacebar')) return;
          const slide = e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          e.preventDefault();
          navigateBySlide(slide);
        });
      }

      if (swiper) {
        buildTabs();
        initTabs();
        initButtonActions();
        initSlideLinkActions();
        if (showPagination && useCustomTabs) {
          updateVerticalTabs(0);
          updateHorizontalTabs(0);
          updateHorizontalTabsPc(0);
          if (enableAutoplay && swiper.autoplay && swiper.autoplay.running) {
            setTimeout(() => startProgress(), 100);
          }
        } else {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
        }
        on(window, 'resize', function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (swiper && swiper.update) swiper.update();
          }, 250);
        });
      }

      root.setAttribute(INIT_ATTR, '1');
      controllers.set(root, {
        root: root,
        destroy: function () {
          listeners.forEach(item => item.el.removeEventListener(item.type, item.handler));
          if (resizeTimeout) clearTimeout(resizeTimeout);
          stopProgress();
          if (swiper && swiper.destroy) swiper.destroy(true, true);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page1"]) return;
  try {
    
  (function() {
      let hydro = { install: 'yes', list: [] };
      let lastTar = null;
      const btn = document.getElementById('page1-next');
      const events = Array.prototype.slice.apply(document.getElementById('page1-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item; 
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          if (index === 2) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/bathroom';
          } else if (index === 4) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/balcony';
          } else {
              hydro.list[0] = { result: 'yes' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/hydroease-question2';
          }
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page2"]) return;
  try {
    
  (function() {
      let hydro = window.sessionStorage.getItem('__hydro__');
      try {
          hydro = JSON.parse(hydro);
      } catch (e) {
          hydro = { install: 'no' };
      }
      document.getElementById('page2-no').addEventListener('click', function() {
          hydro.install = 'no';
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

      document.getElementById('page2-yes').addEventListener('click', function() {
          if (hydro.install === 'yes') {
              hydro.list[1] = { result: 'yes' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page3"]) return;
  try {
    
(function() {
    let lastTar = null;
    const btn = document.getElementById('page3-next');
    const events = Array.prototype.slice.apply(document.getElementById('page3-room').querySelectorAll('.item'));
    events.forEach(item => {
        item.addEventListener('click', function() {
            if (lastTar !== null) {
                lastTar.classList.remove('selected');
            } 

            lastTar = item;
            item.classList.add('selected');
            btn.style.display = 'block';
        });
    });

    btn.addEventListener('click', function() {
        const index = Number(lastTar.dataset.index);
        let hydro = window.sessionStorage.getItem('__hydro__');
        try {
            hydro = JSON.parse(hydro);
            if (index === 1) {
                hydro.intall = 'no';
            } else {
                hydro.list[2] = { result: 'yes' };
            }
        } catch (e) {
            hydro = { install: 'no' };
        }
        window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
        location.href = '/pages/hydroease-question4';
    });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page4"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page4-next');
      const events = Array.prototype.slice.apply(document.getElementById('page4-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[3] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question5';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page5"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page5-next');
      const events = Array.prototype.slice.apply(document.getElementById('page5-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[4] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question6';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page6"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page6-next');
      const events = Array.prototype.slice.apply(document.getElementById('page6-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) { 
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[5] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question7';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page7"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page7-next');
      const events = Array.prototype.slice.apply(document.getElementById('page7-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          }); 
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          window.sessionStorage.removeItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[6] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }

          if (hydro.install === 'yes') {
              if (hydro.list.filter(r => r && r.result === 'yes').length === 7) {
                  location.href = '/pages/freo-hydroease-product';
                  return false;
              }
          }

          location.href = '/pages/freo-product';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixlee-widget"]) return;
  try {
    
  (function(){
    window.PixleeAsyncInit = function() { //2
        Pixlee.init({ apiKey: "t8hC3pFQ7Vc2z2RTMZrm" });
        Pixlee.addCategoryWidget({ widgetId: "7876231", containerId: 'pixlee-widget-box' });
        Pixlee.resizeWidget();
    };
    var pix = document.createElement('script');
    pix.src = '//assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(pix, s);
  })();

  } catch(e) { console.error(e); }
})();
})();
